import { useEffect } from "react";

export default function useDocumentTitle(title, description) {
  useEffect(() => {
    document.title = `${title} | Logix Finance & Investment`;
  }, [title]);

  useEffect(() => {
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute("content", description);
    }
  }, [description]);
}
